import React from "react";

const STATUS_CLASS_MAP = {
    ["INITIATED"]: "payment-initiated",
    ["USER PAID"]: "payment-initiated",
    ["SUCCESS"]: "payment-paid",
    ["ONHOLD"]: "payment-onhold",
    ["REJECTED"]: "payment-cancelled",
    ["CANCELLED"]: "payment-cancelled",
    ["FAILED"]: "payment-failed",
    ["CHARGED BACK"]: "payment-chargeback",
    ["DISCREPANCY"]: "payment-discrepancy"
};

const STATUS_COLOR_MAP = {
    ["INITIATED"]: "#5C9EEB",
    ["USER PAID"]: "#5C9EEB",
    ["SUCCESS"]: "#197E23",
    ["ONHOLD"]: "#FFCE22",
    ["REJECTED"]: "#FF8A00",
    ["CANCELLED"]: "#FF8A00",
    ["FAILED"]: "#FF6A6A",
    ["CHARGED BACK"]: "#DD5CEB",
    ["DISCREPANCY"]: "#B7791F"
};

const StatusBadge = ({ status }) => {

    if (!status) {
        return "--";
    }

    const statusUpper = (status || "").toUpperCase();

    const className = STATUS_CLASS_MAP[statusUpper] || "payment-initiated";
    const fillColor = STATUS_COLOR_MAP[statusUpper] || "#5C9EEB";

    return <>
        <div
            className={className}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                fill={fillColor}
                data-name="Layer 1"
                viewBox="0 0 24 24"
            >
                <path d="M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0z"></path>
            </svg>
            {status}
        </div>
    </>
};

export default StatusBadge;